// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenuQuickstart{
    max-width: 100%;
    max-height: 100%;
}

.SideMenuQuickstart_content {
    padding: 20px;
    overflow-y: auto;
    max-height: calc(100vh - 100px);
}

.SideMenuQuickstart_welcome {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 20px;
    border-radius: 12px;
    margin-bottom: 20px;
    text-align: center;
}

.SideMenuQuickstart_welcome h1 {
    margin: 0 0 10px 0;
    font-size: 24px;
    font-weight: bold;
}

.SideMenuQuickstart_welcome p {
    margin: 0;
    font-size: 14px;
    opacity: 0.9;
}



.SideMenuQuickstart_sectionHeader {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
}

.SideMenuQuickstart_stepNumber {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    font-size: 16px;
    font-weight: bold;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.SideMenuQuickstart_checkmark {
    background: #28a745;
    color: white;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    font-size: 14px;
    font-weight: bold;
}

.SideMenuQuickstart_sectionTitle {
    font-size: 18px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0;
    line-height: 1.3;
}

.SideMenuQuickstart_sectionContent {
    color: #6c757d;
    line-height: 1.5;
}

.SideMenuQuickstart_sectionContent p {
    margin: 12px 0;
    line-height: 1.6;
}

.SideMenuQuickstart_sectionContent strong {
    color: #2c3e50;
    font-weight: 600;
}

.SideMenuQuickstart_bulletPoint {
    display: flex;
    align-items: flex-start;
    margin: 12px 0;
    padding: 8px 12px;
    background: #f8f9fa;
    border-left: 4px solid #17a2b8;
    border-radius: 0 8px 8px 0;
}

.SideMenuQuickstart_bullet {
    margin-right: 8px;
    font-size: 16px;
    flex-shrink: 0;
}

.SideMenuQuickstart_actionItem {
    display: flex;
    align-items: flex-start;
    margin: 12px 0;
    padding: 12px 16px;
    background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%);
    border-radius: 12px;
    border: 1px solid #e1f5fe;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.SideMenuQuickstart_actionIcon {
    margin-right: 12px;
    font-size: 18px;
    flex-shrink: 0;
}

.SideMenuQuickstart_section {
    background: #ffffff;
    border: 2px solid #e9ecef;
    border-radius: 16px;
    padding: 24px;
    margin-bottom: 20px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.SideMenuQuickstart_section::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
}

.SideMenuQuickstart_section:hover {
    border-color: #667eea;
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.15);
    transform: translateY(-2px);
}

.SideMenuQuickstart_completion {
    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    color: white;
    padding: 20px;
    border-radius: 12px;
    text-align: center;
    margin-top: 20px;
}

.SideMenuQuickstart_completion h2 {
    color: #333;
    margin-bottom: 10px;
}

.sideMenuQuickstart_video {
    margin: 20px 0;
    display: flex;
    justify-content: center;
}

.sideMenuQuickstart_video video {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sideMenu/SideMenuQuickstart.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,YAAY;AAChB;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,6DAA6D;IAC7D,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,WAAW;IACX,4DAA4D;AAChE;;AAEA;IACI,qBAAqB;IACrB,gDAAgD;IAChD,2BAA2B;AAC/B;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,wCAAwC;AAC5C","sourcesContent":[".SideMenuQuickstart{\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.SideMenuQuickstart_content {\n    padding: 20px;\n    overflow-y: auto;\n    max-height: calc(100vh - 100px);\n}\n\n.SideMenuQuickstart_welcome {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    padding: 20px;\n    border-radius: 12px;\n    margin-bottom: 20px;\n    text-align: center;\n}\n\n.SideMenuQuickstart_welcome h1 {\n    margin: 0 0 10px 0;\n    font-size: 24px;\n    font-weight: bold;\n}\n\n.SideMenuQuickstart_welcome p {\n    margin: 0;\n    font-size: 14px;\n    opacity: 0.9;\n}\n\n\n\n.SideMenuQuickstart_sectionHeader {\n    display: flex;\n    align-items: center;\n    margin-bottom: 16px;\n}\n\n.SideMenuQuickstart_stepNumber {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 16px;\n    font-size: 16px;\n    font-weight: bold;\n    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);\n}\n\n.SideMenuQuickstart_checkmark {\n    background: #28a745;\n    color: white;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 12px;\n    font-size: 14px;\n    font-weight: bold;\n}\n\n.SideMenuQuickstart_sectionTitle {\n    font-size: 18px;\n    font-weight: 600;\n    color: #2c3e50;\n    margin: 0;\n    line-height: 1.3;\n}\n\n.SideMenuQuickstart_sectionContent {\n    color: #6c757d;\n    line-height: 1.5;\n}\n\n.SideMenuQuickstart_sectionContent p {\n    margin: 12px 0;\n    line-height: 1.6;\n}\n\n.SideMenuQuickstart_sectionContent strong {\n    color: #2c3e50;\n    font-weight: 600;\n}\n\n.SideMenuQuickstart_bulletPoint {\n    display: flex;\n    align-items: flex-start;\n    margin: 12px 0;\n    padding: 8px 12px;\n    background: #f8f9fa;\n    border-left: 4px solid #17a2b8;\n    border-radius: 0 8px 8px 0;\n}\n\n.SideMenuQuickstart_bullet {\n    margin-right: 8px;\n    font-size: 16px;\n    flex-shrink: 0;\n}\n\n.SideMenuQuickstart_actionItem {\n    display: flex;\n    align-items: flex-start;\n    margin: 12px 0;\n    padding: 12px 16px;\n    background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%);\n    border-radius: 12px;\n    border: 1px solid #e1f5fe;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.SideMenuQuickstart_actionIcon {\n    margin-right: 12px;\n    font-size: 18px;\n    flex-shrink: 0;\n}\n\n.SideMenuQuickstart_section {\n    background: #ffffff;\n    border: 2px solid #e9ecef;\n    border-radius: 16px;\n    padding: 24px;\n    margin-bottom: 20px;\n    transition: all 0.3s ease;\n    position: relative;\n    overflow: hidden;\n}\n\n.SideMenuQuickstart_section::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 4px;\n    background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);\n}\n\n.SideMenuQuickstart_section:hover {\n    border-color: #667eea;\n    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.15);\n    transform: translateY(-2px);\n}\n\n.SideMenuQuickstart_completion {\n    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n    color: white;\n    padding: 20px;\n    border-radius: 12px;\n    text-align: center;\n    margin-top: 20px;\n}\n\n.SideMenuQuickstart_completion h2 {\n    color: #333;\n    margin-bottom: 10px;\n}\n\n.sideMenuQuickstart_video {\n    margin: 20px 0;\n    display: flex;\n    justify-content: center;\n}\n\n.sideMenuQuickstart_video video {\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
